module.exports = "mutation paymentMethodCreate($token:String!){paymentMethod(token:$token){id tokenId cardBrand cardLast4 created active type}}"